export default __webpack_public_path__ + "static/media/resume-screenshot.7f95e53e.png";